import '@qapline/ui/styles/global';
import './index.css';
import 'utils/sentryInstrument';
import './config/runtime';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { Application } from 'core/application';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <Application />
    </React.StrictMode>,
);
